export const MEALS_LIST_PROPERTIES = [
  'id',
  'nameForClient',
  'workingName',
  'rateAVG',
  'productionImage',
  'availableInVariableOffer',
  'availableInFixedOffer',
];
